import { OneColumn } from 'components/page';
import { useClientContext } from 'context/ClientContext';
import { TabelaPrecoGrid, TabelaPrecoListFilter, TabelaPrecoRelatorio } from 'pages/compra/tabela-preco/components';

export function TabelaPrecoListComp() {
    const { fgDownloadRelatorioReport } = useClientContext();

    return (
        <OneColumn title="Consulta de Tabelas de Preços" goBackButton createButton={false}>
            <TabelaPrecoListFilter />

            {fgDownloadRelatorioReport && <TabelaPrecoRelatorio />}

            <TabelaPrecoGrid />
        </OneColumn>
    );
}
